<template>
    <div class="steps-three">
        <a-form :form="form" @submit="handleSubmit" >
            <a-form-item label="小程序首页场地展示图" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true">
                <image-uploader ref="uploader" :disabled="stepThreeDisable" :value="appHomepageUrl" @uploaded="uploaded"></image-uploader>
            </a-form-item>
            <!-- <a-form-item label="展示标题" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input :disabled="stepThreeDisable" v-decorator="['showTitle',{rules: [{required: true, message: '请输入展示标题（限15以内）',max: 15}]}]"></a-input>
            </a-form-item> -->
            <a-form-item label="小程序门店图文介绍" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true">
                <rich-text ref="rich" :list="contentList" v-if="!stepThreeDisable"></rich-text>
                <rich-text-viewer :list="contentList" v-else></rich-text-viewer>
            </a-form-item>
            <a-form-item class="text-center" v-if="showStepThreeBtn">
                <a-button @click="backStep">上一步</a-button>
                <a-button type="primary" html-type="submit" >下一步</a-button>
            </a-form-item>
        </a-form>
    </div>
</template>

<script>

    /**
     * 场地图文详情组件
     * @prop {Boolean} stepThreeDisable 禁用所有表单项，第四步和查看详情时为true
     * @prop {Boolean} showStepThreeBtn 第四步时控制操作按钮是否展示
     * @prop {Object} allData 编辑和查看详情时获取所有接口数据
     *
     */

    import ImageUploader from '@/components/common/image-uploader.component'
    import richText from '@/components/modules/rich-text.component'
    import richTextViewer from '@/components/modules/rich-text-viewer.component'
    export default {
        name: "newStepThree",
        zh: '场地图文详情组件',
        data() {
            return {
                labelCol: {span: 8},
                wrapperCol: {span: 8},
                loading: false,
                appHomepageUrl: '',
                contentList: []
            }
        },
        props: {
            stepThreeDisable: {type: Boolean},
            showStepThreeBtn: {type: Boolean},
            allData: { type: Object },
            current: { type: Number },
        },
        components: {
            ImageUploader,
            richText,
            richTextViewer
        },
        methods: {
            // 当点击提交时将第一步的全部内容传给父组件 同时隐藏第二步 显示第三步
            handleSubmit (e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        !this.stepThreeDisable && this.getContentList();
                        if (!Boolean(this.appHomepageUrl)) {
                            this.$message.error('请添加小程序首页场地展示图！');
                            return false;
                        }
                        if (this.contentList.length === 0) {
                            this.$message.error('请添加小程序门店图文介绍！');
                            return false;
                        }
                        this.$emit('stepThreeData',{
                            current: 3,
                            showTitle: '',
                            appHomepageUrl: this.appHomepageUrl,
                            content: JSON.stringify(this.contentList)
                        })
                    }
                });
            },
            uploaded(val) {
                this.appHomepageUrl = val
            },
            getContentList () {
                this.contentList = this.$utils.deepClone(this.$refs.rich.getData());
            },
            getThreeData () {
                this.appHomepageUrl = this.allData.appHomepageUrl;
                this.contentList = JSON.parse(this.allData.content);
                // this.$nextTick(() => {
                //     this.form.setFieldsValue(
                //         valuesForm
                //     );
                // })
            },
            backStep() {
                this.$emit('stepThreeData',{
                    current: 1,
                })
            }
        },
        beforeCreate () {
            this.form = this.$form.createForm(this);
        },
        mounted() {
            // this.$route.name === 'detailBranchStore' && this.getThreeData()
        },
        watch: {
            'current'(newVal) {
                this.current = newVal
                if(newVal === 2) {
                    this.$route.name !== 'addBranchStore' && this.getThreeData()
                }else if(newVal === 3) {
                    this.$route.name === 'detailBranchStore' && this.getThreeData()
                }
            }
        }
    }
</script>

<style lang="scss" >
    .steps-three {
        .avatar-uploader > .ant-upload {
            width: 230px;
            height: 128px;
        }
        .ant-upload-select-picture-card .ant-upload-text {
            margin-top: 8px;
            color: $text-color-black-65;
        }
    }
</style>
